import { outOfBandThemeColors } from '@/theme/colors';
import { capitalizeFirstLetter } from '@montugroup/circuit-shared/utils/string';
import { Chip } from '@montugroup/design-system';
import { useTheme } from '@mui/material';
import type { ErxStatus } from '../escript/token/types';

interface ErxStatusChipProps {
  status: ErxStatus;
}

export function ErxStatusChip({ status }: ErxStatusChipProps) {
  const theme = useTheme();
  const genericChipStyles = {
    success: {
      color: theme.palette.success.main,
      backgroundColor: theme.palette.success.light,
    },
    error: {
      color: theme.palette.error.main,
      backgroundColor: outOfBandThemeColors.uMeds.merino100,
    },
    info: {
      color: theme.palette.info.main,
      backgroundColor: theme.palette.info.light,
    },
  };

  const chipStyleByStatus = {
    active: genericChipStyles.success,
    cancelled: genericChipStyles.error,
    dispensed: genericChipStyles.error,
    ceased: genericChipStyles.error,
    expired: genericChipStyles.error,
    disabled: genericChipStyles.error,
    deferred: genericChipStyles.info,
    owing: genericChipStyles.info,
    pending: genericChipStyles.info,
  };

  if (!status) {
    return null;
  }

  const chipStyles = chipStyleByStatus[status];

  return (
    <Chip
      label={capitalizeFirstLetter(status)}
      sx={{
        fontWeight: 600,
        paddingLeft: 1,
        paddingRight: 1,
        paddingTop: 2,
        paddingBottom: 2,
        border: `1px solid`,
        ...chipStyles,
        borderColor: chipStyles.color,
      }}
      variant="outlined"
    />
  );
}
